// extracted by mini-css-extract-plugin
export var links = "Links-module--links--1xcN5";
export var icon = "Links-module--icon--2PN03";
export var fill = "Links-module--fill--bSY55";
export var stroke = "Links-module--stroke--3c00X";